import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=91a56ae2&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=91a56ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a56ae2",
  null
  
)

export default component.exports